<template>
    <div style="display: flex; justify-content: center;" :class="classContent">
        <div class="p-3 position-relative" :class="classBody" :style="'width:' + width">
          <div class="row">
            <div class="col-12" :class="minimize ? 'pb-0' : ''">
                  <h4 class="text-primary mb-0" style="font-weight: 500;">{{ title }}</h4>
              </div>
          </div>
          <form class="row align-items-end" v-show="minimize">
              <div class="col-lg-3">
                  <div class="form-group mb-0">
                      <small>Categoría (Opcional)</small>
                      <v-autocomplete
                          v-model="data.category"
                          :items="categories"
                          class="form-control form-control-lg"
                          item-text="code"
                          item-value="code"
                          placeholder="RR" :disabled="tracking.length > 0" :class="tracking.length > 0 ? 'bg-light' : ''"
                          clearable
                          dense
                          outlined
                          hide-details>
                      </v-autocomplete>
                  </div>
              </div>
              <div class="col-lg-6">
                  <div class="form-group mb-0">
                      <small>Numeración (Opcional)</small>
                      <input v-model="data.number" :disabled="tracking.length > 0" type="text" class="form-control form-control-lg" @keypress="NUMBER" placeholder="123456789">
                  </div>
              </div>
              <div class="col-lg-3">
                  <div class="form-group mb-0">
                      <small>Pais de origen (Opcional)</small>
                      <v-autocomplete
                          v-model="data.country"
                          :items="countries"
                          class="form-control form-control-lg"
                          :item-text="(e) => e.code + ' - ' + e.name"
                          item-value="code"
                          placeholder="GT" :disabled="tracking.length > 0" :class="tracking.length > 0 ? 'bg-light' : ''"
                          clearable
                          dense
                          outlined
                          hide-details>
                          <template slot="selection" slot-scope="data">
                            {{ data.item.code }}
                          </template>
                      </v-autocomplete>
                  </div>
              </div>
              <div class="col-12 py-0"></div>
              <div class="col-lg-2">
                  <div class="form-group mb-0">
                      <small>Guia</small>
                      <input v-model="tracking" :disabled="data.category || data.number || data.country" type="text" class="form-control form-control-lg" placeholder="">
                  </div>
              </div>
              <div class="col-lg-3">
                  <div class="form-group mb-0">
                      <small>Nombre (Opcional)</small>
                      <input v-model="data.name" type="text" class="form-control form-control-lg" placeholder="">
                  </div>
              </div>
              <div class="col-lg-4">
                  <div class="form-group mb-0">
                      <small>Dirección (Opcional)</small>
                      <input v-model="data.address" type="text" class="form-control form-control-lg" placeholder="">
                  </div>
              </div>
              <div class="col-lg-3">
                  <div class="form-group mb-0">
                      <button type="button" :disabled="!disabled" @click="onEvent(data)" class="btn btn-primary btn-lg btn-block font-weight-bold">BUSCAR</button>
                  </div>
              </div>
          </form>
          <button type="button" @click="minimize = !minimize" class="position-absolute btn btn-primary" style="top: 10px; right: 0px;left: auto; z-index: 1000;">{{ minimize ? '-' : '+' }}</button>
        </div>
    </div>
</template>
<script>
import countries from '@/assets/json/countries.json'
import categories from '@/assets/json/categories.json'
export default {
  props: {
    title: {
      type: String,
      default: 'Seguimiento de envios'
    },
    classContent: {
      type: String,
      default: ''
    },
    classBody: {
      type: String,
      default: ''
    },
    width: {
      type: String,
      default: '80%'
    },
    to: {
      type: String,
      default: 'ClientLocator'
    }
  },
  computed: {
    disabled: function () {
      let tracking = this.data.category || this.data.number || this.data.country
      return this.data ? tracking || this.data.name || this.data.address || this.tracking : false
    }
  },
  data () {
    return {
      data: {},
      categories,
      countries,
      minimize: true,
      tracking: ''
    }
  },
  methods: {
    onEvent: function (data) {
      let tracking = this.tracking ? this.tracking : (data.category + data.number + data.country)
      this.$router.push({ name: this.to, query: { tracking: tracking, name: data.name, address: data.address } }).catch(() => {})
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/company/components/AdvancedSearch.vue